import $ from 'jquery'
import VectorLayer from 'ol/layer/Vector'
import { isOffline } from './offline/offline'
import TocUI from './ui/Toc'

/**
 * Table Of Contents (layer list) class
 * @param {Object} config
 * @constructor
 */
export default function Toc(config) {
  $.extend(this, config)

  this.config.layers.forEach(function(layer, index) {
    layer.index_ = index
    layer.mapLayer_ = layer.mapLayer_
  })

  this.ui = new TocUI({
    config: this.config,
    map: this.map,
    toc: this
  })

  this.ui.render()
}

/**
 * Toggles map layer visibility
 * @param {number} index index of layer
 * @param {boolean} visible show or hide layer (reflects on/off state on button)
 */
Toc.prototype.toggleLayer = function(index, visible) {
  const layer = this.config.layers[index]
  const alwaysOnline = layer.metadata && layer.metadata.alwaysOnline
  layer.visible = visible
  if (isOffline && !alwaysOnline) {
    if (layer.offlineLayer_) layer.offlineLayer_.setVisible(visible)
    if (layer.optLayer_) layer.optLayer_.setVisible(visible)
    if (layer.mapLayer_ instanceof VectorLayer)
      layer.mapLayer_.setVisible(visible)
  } else {
    layer.mapLayer_.setVisible(visible)
  }
}
